/**
 * Environment utilities for signals package
 */

// Type augmentation for Vite's import.meta.env
declare global {
  interface ImportMeta {
    env?: {
      VITE_LOG_SIGNALS?: string;
      [key: string]: string | undefined;
    };
  }
}

/**
 * Check if signal logging is enabled via environment variable.
 *
 * Supports:
 * - Vite: import.meta.env.VITE_LOG_SIGNALS
 * - Node.js: process.env.LOG_SIGNALS
 *
 * Set to 'true' to enable signal logging.
 *
 * Note: Vite statically replaces import.meta.env at build time,
 * so this must use the direct property access syntax.
 */
export function isSignalLoggingEnabled(): boolean {
  // Vite statically replaces import.meta.env.VITE_* at build time
  // This direct access is required for the replacement to work
  if (import.meta.env?.VITE_LOG_SIGNALS === 'true') {
    return true;
  }

  // Check Node.js environment variable (for SSR or testing)
  // Use globalThis to access process in a type-safe way
  const nodeProcess = (globalThis as { process?: { env?: Record<string, string> } }).process;
  if (nodeProcess?.env?.LOG_SIGNALS === 'true') {
    return true;
  }

  return false;
}
